import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "@mui/material/styles";
import Theme from "./theme";

import {
  AdminUserContextProvider,
  UserContextProvider,
  ProjectContextProvider,
  MapContextProvider,
  OffersContextProvider,
  AppContextProvider,
  TransactionsTrackerContextProvider,
  HeatMapContextProvider,
  SubdivisionContextProvider,
} from "context";

// Utility to compose providers
const composeProviders =
  (...providers) =>
  ({ children }) =>
    providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children
    );

const AppProviders = composeProviders(
  AppContextProvider,
  UserContextProvider,
  AdminUserContextProvider,
  ProjectContextProvider,
  OffersContextProvider,
  TransactionsTrackerContextProvider,
  HeatMapContextProvider,
  SubdivisionContextProvider,
  MapContextProvider
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function ProvidersWrapper({ children }) {
  return (
    <ThemeProvider theme={Theme}>
      <QueryClientProvider client={queryClient}>
        <AppProviders>
          <div style={{ width: "100%", minHeight: "100%" }}>{children}</div>
        </AppProviders>
        {process.env.NODE_ENV === "development" && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </ThemeProvider>
  );
}
